import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Typography} from 'src/components';

export type NotFoundProps = {
  text: string;
};

export const NotFound: React.FC<NotFoundProps> = ({text}) => {
  return (
    <View style={styles.container}>
      <Typography variant={'h1'} text={text} containerStyle={styles.h1} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // marginTop: 40,
  },
  h1: {
    // marginTop: 50,
  },
});
